import styled from "styled-components";
import Colors from "../../constants/Colors";

export const BottomButton = styled.div`
    background-color: ${Colors.SPM700};
    font-size: 14px;
    height: 35px;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
    text-align: center;
    margin-top: -5px;
    margin-bottom: -8px;
    padding: 2px 6px;
    color: white;
`